import { pdfjs } from 'react-pdf'

let workerConfigured = false

function ensurePdfWorker() {
  if (workerConfigured) return
  pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`
  workerConfigured = true
}

function canvasToJpegBlob(canvas, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('No se pudo convertir PDF a JPEG'))
          return
        }
        resolve(blob)
      },
      'image/jpeg',
      quality,
    )
  })
}

async function renderPageToJpegBlob(page, { quality, scale }) {
  const viewport = page.getViewport({ scale })
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  canvas.width = viewport.width
  canvas.height = viewport.height

  await page.render({ canvasContext: context, viewport }).promise
  return canvasToJpegBlob(canvas, quality)
}

/** Convierte todas las páginas de un PDF (Blob) a JPEG */
export async function convertPdfBlobToJpegBlobs(
  pdfBlob,
  { quality = 0.92, scale = 2 } = {},
) {
  ensurePdfWorker()

  const arrayBuffer = await pdfBlob.arrayBuffer()
  const pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise
  const pages = []

  for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber += 1) {
    const page = await pdf.getPage(pageNumber)
    const blob = await renderPageToJpegBlob(page, { quality, scale })
    pages.push({ pageNumber, blob })
  }

  return pages
}

/** Compat: primera página como un solo Blob */
export async function convertPdfBlobToJpegBlob(pdfBlob, options = {}) {
  const pages = await convertPdfBlobToJpegBlobs(pdfBlob, options)
  return pages[0]?.blob ?? null
}
